// extracted by mini-css-extract-plugin
module.exports = {"root":"SportSidebar_root__Kio8c","overlay":"SportSidebar_overlay__M15XX","isOpened":"SportSidebar_isOpened__jiTiD","visible":"SportSidebar_visible__z3Um_"};